<template>
  <div class="product">
    <div class="title">
      <el-breadcrumb >
        <el-breadcrumb-item>价格预警</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <el-card>
        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <el-tab-pane label="日"
                       name="0"></el-tab-pane>
          <el-tab-pane label="周"
                       name="1"></el-tab-pane>
        </el-tabs>
        <el-row :gutter="80"
                class="dataTop">
          <el-col :span="12">
            <el-row :gutter="40">
              <el-col :span="12"
                      class="iboxs">
                <div class="ibox">
                  <p>最近低价sku总数</p>
                  <h4>{{ count }}</h4>
                  <span>条</span>
                </div>
                <div class="ibox">
                  <p>最新低价sku占比</p>
                  <h4 class="red">{{ percentage }}</h4>
                  <span>百分比</span>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <div class="subtitle">
              <h4>各渠道卖家统计</h4>
            </div>
            <div id="EChart"
                 style="width: 100%; height: 300px; border: 1px solid #ddd"></div>
          </el-col>
        </el-row>
        <el-row :gutter="40"
                style="margin: 40px 0">
          <el-col :span="12">
            <div class="subtitle">
              <h4>最近趋势</h4>
            </div>
            <div id="EChart1"
                 style="width: 100%; height: 300px; border: 1px solid #ddd"></div>
          </el-col>
          <el-col :span="12">
            <div class="subtitle">
              <h4>卖家地图位置分布</h4>
            </div>
            <div id="EChart2"
                 style="width: 100%; height: 300px; border: 1px solid #ddd"></div>
          </el-col>
        </el-row>
        <div class="form">
          <el-form v-model="formInline"
                   inline
                   class="formInline">
            <div>
              <el-form-item label="授权类型：">
                <el-select v-model="formInline.type"
                           placeholder="请选择授权类型"
                           clearable>
                  <el-option label="授权"
                             value="1"> </el-option>
                  <el-option label="未授权"
                             value="2"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="平台：">
                <el-select v-model="formInline.platform"
                           placeholder="请选择平台"
                           clearable>
                  <el-option v-for="item in options"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="关键字：">
                <el-input v-model="formInline.keyword"
                          placeholder="请输入关键字"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item>
                <el-button @click="reset">重 置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"
                           @click="getTableList(1)">查 询</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="table">
          <el-table :data="tableData"
                    v-loading="loadingTable"
                    style="width: 100%"
                    border>
            <el-table-column align="center"
                             prop="id"
                             label="ID"
                             width="55"> </el-table-column>
            <el-table-column align="center"
                             prop="name"
                             label="产品名称"
                             width="140"
                             show-overflow-tooltip> </el-table-column>
            <el-table-column align="center"
                             prop="name"
                             label="SKU名称"
                             width="140"
                             show-overflow-tooltip> </el-table-column>
            <el-table-column align="center"
                             prop="shop_is_auth"
                             label="是否授权"
                             width="140">
              <template slot-scope="{ row }">
                {{ row.is_auth == 1 ? "已授权" : "未授权" }}
              </template>
            </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="platform_name"
                             label="平台"> </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="sell_price"
                             sortable
                             label="页面价格"> </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="final_price"
                             sortable
                             label="折后价格"> </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="left_price"
                             sortable
                             label="差价"> </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="console_price"
                             sortable
                             label="监测价格"> </el-table-column>
           <el-table-column align="center"
                             width="140"
                             prop="take_part_in"
                             label="破价原因">
             <template slot-scope="{ row }" >
                <div v-if="row.warning_type==2">
                <span v-for="(item,index) in row.take_part_in.split(',')" :key="index">
                   {{ item == 1 ? "秒杀活动" : item == 2 ? "plus会员" : item == 3 ? "品牌闪购" :item == 4 ? "满减卷" :item == 5 ? "促销满减" :item == 6 ? "满折":item == 7 ? "满赠":item == 8 ? "预售":"赠品" }}
                </span></div>
                <span  v-else>-</span> 
              </template> 
            </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="create_time"
                             label="更新时间"> </el-table-column>
            <el-table-column align="center"
                             width="140"
                             prop="warning_type"
                             label="价格预警">
              <template slot-scope="{ row }">
              <span style="color:red">{{ row.warning_type == 1 ? "价格上限" : row.warning_type == 2 ? "价格下限" : "政府价格上限" }}</span> 
              </template>
            </el-table-column>
            <el-table-column align="center"
                             width="140"
                             label="操作"
                             fixed="right">
              <template slot-scope="{ row }">
                <div class="link">
                  <el-link type="primary"
                           @click="RecordDetail(row)">详情</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pageSize">
          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="page"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="size"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div>
      </el-card>
    </div>
    <div v-if="closeModelView">
      <Record @closeModel="initModel"
              :url='url'
              :cid='cid'
              :plaid='plaid'
              :constype='constype'
              :pid='pid'></Record>

    </div>
  </div>
</template>

<script>
import moment from 'moment';
const echarts = require("echarts");
import Record from "@/components/Modules/Monitor/Record.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      closeModelView: false,
      formInline: {
        type: "",
        platform: "",
        keyword: "",
      },
      loadingTable: false,
      tableData: [],
      total: 0,
      page: 1,
      size: 10,
      options: [],
      count: "0",
      percentage: "0%",
      activeName: "0",
      areaX: [],
      areaY: [],
      authorizeX: [],
      authorizeY: [],
      platX: [],
      platData: [],

      url: '',
      pid: '',
      cid:'',
      plaid:'',
      constype:'',
      last_monday: '',
      nowTime: '',
      obj: {}
    };
  },
  components: {
    Record,
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  created () {
    let nowTime = this.initDate()
    this.nowTime = nowTime
    this.initMondayTime()
      this.getArea();
  },
  async mounted () {
    await this.getPlatform();
    await this.getTableList();
    this.getRenderer();
    this.getRenderer1();
    this.getSkuChart();
  
    this.getplatCount(this.nowTime, this.nowTime)
    this.getauthorizeCount(this.nowTime, this.nowTime)

  },
  methods: {
    initModel () {
      this.closeModelView = false
    },
    ...mapActions({
      shopList: "detect/shopList",
      platformSelect: "detect/platformSelect", //平台列表
      skuChart: "detect/skuChart", //平台列表
      pricemonitorList: "detect/pricemonitorList",
      areaCount: "detect/areaCount", //地理位置
      authorizeCount: "detect/authorizeCount", //授权
      platCount: "detect/platCount", //授权
    }),
    //地理位置的接口
    getArea () {
      this.areaCount({ token: this.getToken }).then(({ data }) => {
        if (data.code == 1) {
          this.areaX = data.data.map((item) => item.name);
          this.areaY = data.data.map((item) => item.value);
         // console.log(this.areaY,  this.areaX,'地理图')
          this.$nextTick(()=>{
        this.getRenderer2(this.areaX,this.areaY);
          })
         
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    //授权的接口
    getauthorizeCount (startTime, endTime) {
      this.authorizeCount({ token: this.getToken, startTime, endTime, }).then(({ data }) => {
        if (data.code == 1) {
          if (this.activeName == '0') {
            if (data.data.length > 0) {
              let x = []
              x = ['0-3', '3-6', '6-9', '9-12', '12-15', '15-18', '18-21', '21-24']
              data.data[0].data.forEach(el => {
                this.authorizeY.push(el.result)
              })
              if (this.authorizeY.length) {
                this.authorizeX = x.slice(0, this.authorizeY.length)
              }
            }
             //  console.log(this.authorizeY, this.authorizeY,'授权的接口')
          } else {
            data.data.forEach(el => {
              this.authorizeX.push(el.code)
              this.authorizeY.push(el.data[el.data.length - 1].result)
            })
           // console.log(this.authorizeY, this.authorizeY,'授权的接口')
          }
          this.getRenderer1();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    //平台的接口
    getplatCount (start_time, end_time) {
      this.platData = []
      this.platX = []
      this.platCount({ token: this.getToken, start_time, end_time }).then(({ data }) => {
        if (data.code == 1) {
          let sericeArr = []
          if (this.activeName == '0') {
            if (data.data.length > 0) {
              let x = []
              x = ['0-3', '3-6', '6-9', '9-12', '12-15', '15-18', '18-21', '21-24']
               this.obj = {}        
                for (let i = 0; i < data.data[0].list[0].result.length; i++) {
                  this.obj[i] = []
                  data.data[0].list[0].result.forEach(value => { 
                    this.obj[i].push(value.value)
                    this.platData.push(value.name)
                     })
                }
                console.log( this.obj,'obj----l')
              if (this.obj) {
                this.platData.forEach((el, index) => {
                  let obj = {
                    name: el,
                    data: this.obj[index],
                    type: "line",
                    smooth: true,
                    itemStyle: { normal: { label: { show: true } } }
                  }
                  sericeArr.push(obj)
                  if (sericeArr.length) {
                    this.platX = x.slice(0, sericeArr[0].data.length)
                  }
                })
                this.getRenderer(this.platData, sericeArr)
              }
            }
           console.log( 'this.platX, sericeArr','平台的接口1--------------',this.platData, this.obj)
          } else {
            this.platX = []
            let sericeArr = []
            data.data.forEach((el, index) => {
              this.platX.push(el.date)
              let arr = []
              arr = el.list.slice(0, el.list.length - 1)
              arr[0].result.forEach(elt => {
                this.obj = {}
                for (let i = 0; i < arr[0].result.length; i++) {
                  this.obj[i] = []
                  arr[0].result.forEach(value => { this.obj[i].push(value.value) })
                }
                this.platData.push(elt.name)
              })
            })
            let set = new Set(this.platData)
            this.platData = Array.from(set)
            if (this.obj) {
              this.platData.forEach((el, index) => {
                let obj = {
                  name: el,
                  data: this.obj[index],
                  type: "line",
                  smooth: true,
                }
                sericeArr.push(obj)

              })
              this.getRenderer(this.platData, sericeArr)
            }
            console.log( this.platX, sericeArr,'---平台的接口')
          }
          //this.getRenderer();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    reset () {
      this.formInline = {
        type: "",
        platform: "",
        keyword: "",
      };
      this.getTableList(1)
    },
    initDate () {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return year + '-' + month + '-' + day;
    },
    initMondayTime () {
      let weekOfday = moment(this.nowTime, "YYYY-MM-DD").format("E"); //计算今天是这周第几天
      let last_monday = moment(this.nowTime)
        .subtract(weekOfday - 1, "days")
        .format("YYYY-MM-DD"); //周一日期
      this.last_monday = last_monday;

      /*  let last_sunday = moment(this.endDate).weekday(7).format("YYYY-MM-DD"); //周日日期
       this.last_sunday = last_sunday; */
    },
    handleClick (val) {
      this.authorizeX = []
      this.authorizeY = []
      this.getSkuChart()
      if (val.index == 0) {
        this.getauthorizeCount(this.nowTime, this.nowTime)
        this.getplatCount(this.nowTime, this.nowTime)
      } else {
        this.getauthorizeCount(this.last_monday, this.nowTime)
        this.getplatCount(this.last_monday, this.nowTime)

      }
    },
    getSkuChart () {
      let params = {
        token: this.getToken,
        type: 2,
        // plan_id: this.$route.params.id,
      };
      this.skuChart(params).then(({ data }) => {
        if (data.code == 1) {
          this.count = data.data.count;
          this.percentage = data.data.percentage;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getPlatform () {
      let params = {
        token: this.getToken,
      };
      this.platformSelect(params).then(({ data }) => {
        if (data.code == 1) {
          this.options = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getTableList () {
      this.loadingTable = true
      try {
        let params, url;
        params = {
          token: this.getToken,
          platform_id: this.formInline.platform, //平台id  非必填
          is_auth: this.formInline.type, //是否授权  非必填
          keywords: this.formInline.keyword, //关键词  非必填
          page: this.page, //当前页数
          size: this.size, //每页显示条数
        };
        url = this.pricemonitorList;
        url(params).then(({ data }) => {
          if (data.code == 1) {
            this.loadingTable = false
            this.tableData = data.data.list
            this.total =parseInt(data.data.count) 
            if (this.tableData.length > 0) {
              this.tableData.forEach((item) => {
                item.platform = this.options.find((v) => item.platform_id == v.id).name || "-";
              });
            }
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    RecordDetail (item) {
      /*this.$refs.refRecord.dialogVisible = true;
        this.$refs.refRecord.getRenderer(); */
      this.url = item.url
      this.closeModelView = true
      this.pid = item.console_product_id
      this.plaid = item.console_plan_id
      this.cid = item.console_plan_id
      this.constype = item.console_type
    },
    getRenderer2 (X,Y) {
      console.log(X,'X-----')
      let EChart = echarts.init(document.getElementById("EChart2"));
      let config = {
        title: {
          show: Y.length == 0,   // 没数据才显示
          extStyle: {
            color: "grey",
            fontSize: 20
          },
          text: "暂无数据",
          left: "center",
          top: "center"
        },
        xAxis: [
          {
            show: false,
            type: "value",
          }
        ],
      /*   xAxis: {
          type: "value",
          data:X, 
        }, */
           yAxis: [
          {
            show: true,
            type: "category",
            data: X,}
        ],
    /*     yAxis: {
          type: "category",
        }, */
        series: [
          {
            data: Y,
            type: "bar",
             itemStyle: {
              normal: {
                label: {
                  show: true,      //开启显示
                  position: 'right', //在上方显示
                  textStyle: {     //数值样式
                    color: '#000',
                    fontSize: 10
                  }
                }
              }
            }
          },
          
        ],
      };
      // 设置参数
      EChart.setOption(config);
    },
    getRenderer1 () {
      let EChart = echarts.init(document.getElementById("EChart1"));
      let config = {
        title: {
          show: this.authorizeY.length == 0,   // 没数据才显示
          extStyle: {
            color: "grey",
            fontSize: 20
          },
          text: "暂无数据",
          left: "center",
          top: "center"
        },
        xAxis: {
          type: "category",
          data: this.authorizeX,
        },
        yAxis: {
          type: "value",
        },
        legend: {
          right: 10,
          top: 10,
          orient: 'horizontal',
          color: '#409EFF',
          icon: 'none',
          data: [
            {
              name: '按授权',
              textStyle: {
                fontSize: 12,
                color: '#409EFF',
                fontWeight: 'bolder',
                borderWidth: 1,
                borderType: 'solid',
                borderColor: '#409EFF',
                padding: 5
              },
            }],
        },
        series: [
          {
            name: '按授权',
            data: this.authorizeY,
            type: "bar",
          },
        ],
      };
      // 设置参数
      EChart.setOption(config);
    },
    getRenderer (platData, dataY) {
      let EChart = echarts.init(document.getElementById("EChart"));
      let config = {
        tooltip: {
          show: true,
        },

        legend: {
          icon: "circle",
          itemWidth: 6,
          right: 40,
          top: 10,
          orient: 'horizontal',
          data: platData,
          textStyle: {
            //图例文字的样式
            color: "#333",
            fontSize: 14,
          },
        },
        grid: {
          x: 60,
          y: 40,
          x2: 40,
          y2: 40,
          backgroundColor: "rgba(0,0,0,0)",
          borderWidth: 1,
          borderColor: "#ccc",
        },
        xAxis: {
          type: "category",
          data: this.platX,
        },
        yAxis: {
          type: "value",
        },
        series: dataY,
      };
      // 设置参数
      EChart.setOption(config);
    },

    handleSizeChange (val) {
      this.size = val;
      this.getTableList()
    },
    handleCurrentChange (val) {
      this.page = val;
      this.getTableList()
    },
  },
};
</script>

<style lang="scss" scoped>
.product {
  .title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
  }
  ::v-deep .el-table--border th.el-table__cell {
    background-color: #f8f9fe;
  }
  .dataTop {
    margin-bottom: 40px;
  }
  .main {
    min-width: 1200px;
    margin: 20px;
    .el-card {
      min-height: 780px;
    }
    .el-col {
      .list {
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        li {
          list-style: none;
          padding-left: 14px;
          position: relative;
          margin-bottom: 22px;
          &::before {
            content: "";
            position: absolute;
            width: 6px;
            height: 6px;
            background: #409eff;
            border-radius: 50%;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
          p {
            color: #333;
          }
        }
      }
      .iboxs {
        height: 354px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .ibox {
          height: 160px;
          border: 1px solid #ddd;
          padding: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          color: #333;
          p {
            font-size: 18px;
          }
          h4 {
            font-size: 32px;
            font-weight: 400;
          }
          .red {
            color: #f32b2b;
          }
        }
      }
    }
    .subtitle {
      margin-bottom: 35px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      h4 {
        padding-left: 20px;
        line-height: 18px;
        position: relative;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 2px;
          background: #2448ff;
        }
      }
      p {
        color: #666;
        font-size: 14px;
      }
    }
  }
  .pageSize {
    text-align: right;
    margin-top: 20px;
  }
  .w400 {
    width: 300px;
  }
  .link {
    a {
      margin: 0 8px;
    }
  }
  .formInline {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  ::v-deep .el-card__body {
    padding: 40px;
  }
}

::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
</style>